<template>
    <div id="map-legend-container-id" :class="['d-none', 'd-sm-block', 'map-legend-wrapper', { 'map-legend-mapper-moved': getMapEventsViewOpen }]">
        <div class="py-1 pl-1 legend-title">{{ $t('dashboard.legend-title') }}</div>
        <div class="border-bottom border-color-blue mb-1"></div>
        <div
            v-for="(field, index) in legendItems"
            :key="`field-${index}`"
        >
            <b-form-checkbox  v-model="selected" :value="field.value">
                <div class="d-flex align-items-center map-legend-item">
                    <div class="legend-circle" :class="field.color"></div>
                    <div class="ml-2">
                        <span class="d-inline-block total-per-status">({{ field.total }})</span>
                         {{ $t(field.text) }}
                    </div>

                </div>
            </b-form-checkbox>
        </div>
    </div>
</template>

<script>
    // vuex
    import { mapGetters, mapActions } from 'vuex';
    import {
        SET_MAP_DATA_FILTER,
        SET_MAP_ZOOM,
        SET_ACTIVE_STATION,
        SET_INFO_WINDOW_CLOSE
    } from '../../store/actions/dashboard';

    export default {
        name: "MapLegendContainer",
        computed: {
            ...mapGetters(['getMapEventsViewOpen', 'getPsStatusFilters', 'getActiveStation', 'getGroupedPsStates']),
            selected: {
                get() {
                    return this.getPsStatusFilters;
                },
                set(value) {
                    if (
                        this.getActiveStation.length &&
                        !value.includes(this.getActiveStation[4].toString())
                    ) {
                        this.closeInfoWindow();
                    }
                    this.SET_MAP_DATA_FILTER(value);
                }
            },
            legendItems() {
                return [
                    {text: 'dashboard.legend-normal', value: '1', color: 'green-circle', total: this.getGroupedPsStates[1]},
                    {text: 'dashboard.legend-warning', value: '2', color: 'yellow-circle', total: this.getGroupedPsStates[2]},
                    {text: 'dashboard.legend-danger', value: '0', color: 'red-circle', total: this.getGroupedPsStates[0]},
                    {text: 'dashboard.legend-off', value: '3', color: 'grey-circle', total: this.getGroupedPsStates[3]}
                ];
            }
        },
        methods: {
            ...mapActions([SET_MAP_DATA_FILTER, SET_MAP_ZOOM, SET_ACTIVE_STATION, SET_INFO_WINDOW_CLOSE]),
            closeInfoWindow() {
                this.SET_INFO_WINDOW_CLOSE();
                this.SET_ACTIVE_STATION([]);
                this.SET_MAP_ZOOM(9);
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/variables";

    .map-legend-wrapper {
        position: absolute;
        top: 2%;
        left: 1%;
        display: block;
        background: $whiteColor 0 0 no-repeat padding-box;
        box-shadow: 0 0 10px $shadowColor;
        border-radius: 3%;
        min-width: 235px;
        min-height: 135px;
        z-index: 1;
        padding: 0.5rem;
        transition:left 0.2s ease-in;

        &.map-legend-mapper-moved {
            left: calc(1% + 320px);
            transition:left 0.2s ease-out;
        }
    }

    .map-legend-item {
        cursor: pointer;

        .total-per-status {
            color: $semiDarkGrey;
        }
    }

    .border-color-blue {
        border-bottom-color: $events-border-color !important;
    }

    .legend-title {
        text-align: left;
        font-family: $font-family-sans-serif;
        font-weight: $font-weight-semi-bold;
        font-size: $font-size-base;
        line-height: $font-size-slg;
        letter-spacing: 0;
        color: #6299EB;
        opacity: 1;
    }

    .legend-circle {
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        &.green-circle {
            background-color: $greenColor;
        }
        &.yellow-circle {
            background-color: $orangeColor;
        }
        &.red-circle {
            background-color: $redColor;
        }
        &.grey-circle {
            background-color: $mediumGrey;
        }

        .legend-text {
            text-align: left;
            font-family: $font-family-sans-serif;
            font-weight: $font-weight-normal;
            font-size: $font-size-sm;
            line-height: $font-size-slg;
            letter-spacing: 0;
            color: $blackColor;
            opacity: 1;
        }
    }
</style>